export const PRESERVED_QUERY_NAMESPACES = {
  TEMPLATE: 'template'
} as const
